import { Injectable, signal } from "@angular/core";
import { ConfigService } from "../config/config.service";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";

@Injectable({
	providedIn: 'root',
})

export class PlayerDashboardService {
	constructor(
		public config: ConfigService,
		public userSession: UserSessionService,
		public webservices: WebservicesService
	){}

	private playerDashboardRouteSrc = signal<string>('login'); // Default to Login

	public getPlayerDashboardRouteSrc() {
		return this.playerDashboardRouteSrc.asReadonly();
	}

	public setPlayerDashboardRouteSrc(routeSrc) {
		this.playerDashboardRouteSrc.set(routeSrc);
	}

	public getPlayerDashboard(lobbyName: string){
		const params = {
			customer_id:  this.userSession.customer.customerId,
			session_token: this.userSession.getSessionToken(),
		}

		return this.webservices.get(`lobby/${lobbyName}/get-dashboard-info`, params);

	}
}
